import React, { FC, PropsWithChildren, useMemo } from 'react';

import { StyleGuideContext, StyleGuideOptions, defaultOptions } from './context';

export interface StyleGuideOptionsProviderProps {
  readonly options?: Partial<StyleGuideOptions>;
}

const StyleGuideOptionsProvider: FC<PropsWithChildren<StyleGuideOptionsProviderProps>> = ({
  options = {},
  children,
}) => {
  const value = useMemo(() => ({ ...defaultOptions, ...options }), [options]);

  return <StyleGuideContext.Provider value={value}>{children}</StyleGuideContext.Provider>;
};

export default StyleGuideOptionsProvider;
